<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div class="table-box">
        <!--课程中心表格 - 增加唯一key，手动实现序号-->
        <el-table
          v-if="userModalDetails.sourceType == '3'"
          key="table-course"
          :data="tableData"
          :row-key="(row) => row.courseId || row.id"
          style="width: 100%"
        >
          <el-table-column align="center" label="序号" width="80">
            <!-- 手动计算序号，避免自动index错乱 -->
            <template #default="scope">
              {{ (params.pageNo - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="课程名称"
            prop="courseName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="学习完成人数"
            prop="finishNum"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <el-button type="text" @click="goDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!--会员申请缴费记录表格 - 增加唯一key，手动实现序号-->
        <el-table
          v-if="userModalDetails.sourceType == '5'"
          key="table-member"
          :data="tableData"
          :row-key="(row) => row.id || row.mc + row.uscc"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="单位名称/姓名"
            prop="mc"
            show-overflow-tooltip
            width="460"
          ></el-table-column>
          <el-table-column
            align="center"
            label="社会信用代码/身份证号码"
            prop="uscc"
            show-overflow-tooltip
            width="460"
          ></el-table-column>
          <el-table-column
            align="center"
            label="职务"
            prop="zw"
            show-overflow-tooltip
            width="300"
          >
            <template #default="scope">
              {{
                scope.row.zw
                  ? zwList.find((v) => v.value == scope.row.zw)?.label || ""
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="缴费年度"
            prop="jfnd"
            show-overflow-tooltip
            width="350"
          ></el-table-column>
        </el-table>

        <!--从业人员/项目负责人表格 - 增加唯一key，手动实现序号-->
        <el-table
          v-if="
            userModalDetails.sourceType == '1' ||
            userModalDetails.sourceType == '2'
          "
          key="table-person"
          :data="tableData"
          :row-key="(row) => row.certno || row.certNo || row.id"
          style="width: 100%"
        >
          <el-table-column label="序号">
            <template #default="scope">
              {{ (params.pageNo - 1) * params.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template #default="scope">
              <span v-if="details.title == '从业人员'">{{
                scope.row.name
              }}</span>
              <span v-else-if="details.title == '项目负责人'">{{
                scope.row.certName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="证书编号">
            <template #default="scope">
              <span v-if="details.title == '从业人员'">{{
                scope.row.certno
              }}</span>
              <span v-else-if="details.title == '项目负责人'">{{
                scope.row.certNo
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期限" prop="yxqz"></el-table-column>
        </el-table>

        <div class="page-box">
          <el-pagination
            :page-size="params.pageSize"
            :page-sizes="[10, 50, 100, 200]"
            :total="total"
            layout="total, sizes, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
      <CoursePersonnel
        :details="coursePersonnelDetails"
        @closeDialog="closeDialog"
      ></CoursePersonnel>
    </el-dialog>
  </div>
</template>

<script>
import { getCyry, getXmfzr } from "@/api/home/index";
import CoursePersonnel from "./coursePersonnel.vue";
import { dwCourseList, jkxxList } from "@/api/home/guild";

export default {
  components: { CoursePersonnel },
  props: ["details"],
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      userModalDetails: {},
      coursePersonnelDetails: {
        dialogVisible: false,
      },
      // 会员类型
      vipType: [
        { value: "1", text: "省内企业", title: "省内企业", label: "省内企业" },
        { value: "2", text: "省外企业", title: "省外企业", label: "省外企业" },
        { value: "3", text: "其它", title: "其它", label: "其它" },
      ],
      zwList: [
        { value: "1", text: "会长", title: "会长", label: "会长" },
        { value: "2", text: "副会长", title: "副会长", label: "副会长" },
        { value: "3", text: "监事", title: "监事", label: "监事" },
        { value: "30", text: "监事长", title: "监事长", label: "监事长" },
        { value: "4", text: "常务理事", title: "常务理事", label: "常务理事" },
        { value: "5", text: "副秘书长", title: "副秘书长", label: "副秘书长" },
        { value: "6", text: "理事", title: "理事", label: "理事" },
        { value: "7", text: "会员", title: "会员", label: "会员" },
      ],
      sfffzsList: [
        { value: "0", text: "未发放", title: "未发放", label: "未发放" },
        { value: "1", text: "已发放", title: "已发放", label: "已发放" },
      ],
      jffsList: [
        { label: "现金交费", value: 1 },
        { label: "对工帐户", value: 2 },
        { label: "微信转帐", value: 3 },
        { label: "支付宝转帐", value: 4 },
        { label: "其它方式", value: 5 },
      ],
    };
  },
  watch: {
    details: {
      async handler(newValue) {
        this.dialogVisible = newValue.dialogVisible;
        this.userModalDetails = newValue.data;
        // 清空数据，避免切换时残留
        this.tableData = [];
        this.total = 0;

        if (newValue.dialogVisible) {
          // 重置分页参数
          this.params = { pageNo: 1, pageSize: 10 };
          // 等待DOM更新后再请求数据，避免渲染时机问题
          await this.$nextTick();
          this.getById();
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleSizeChange(val) {
      this.params.pageNo = 1;
      this.params.pageSize = val;
      this.getById();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getById();
    },
    // 优化请求逻辑，增加错误处理
    async getById() {
      try {
        this.tableData = [];
        const { sourceType } = this.userModalDetails;
        const userInfo = JSON.parse(this.$Cookies.get("xh_userInfo")) || {
          user: {},
        };
        const commonParams = { ...this.params };

        // 从业人员
        if (sourceType == 1) {
          const res = await getCyry({
            ...commonParams,
            dwmc: userInfo.user.dwmc,
            iscancel: 0,
          });
          if (res.code == 200) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        }
        // 项目负责人
        else if (sourceType == 2) {
          const res = await getXmfzr({
            ...commonParams,
            certCompany: userInfo.user.dwmc,
          });
          if (res.code == 200) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        }
        // 课程中心
        else if (sourceType == 3) {
          const res = await dwCourseList({
            ...commonParams,
            company: userInfo.user.dwmc,
            token: userInfo.token,
            declareId: this.userModalDetails.declareDetailId,
            templateId: this.userModalDetails.templateId,
          });
          if (res.code == 0 && res.result) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        }
        // 会员申请缴费记录
        else if (sourceType == 5) {
          const res = await jkxxList({
            ...commonParams,
            dwmc: userInfo.user.dwmc,
            token: userInfo.token,
          });
          if (res.code == 0 && res.result) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        }
      } catch (error) {
        console.error("请求表格数据失败:", error);
        this.tableData = [];
        this.total = 0;
      }
    },
    goDetail(it) {
      this.coursePersonnelDetails = {
        ...this.coursePersonnelDetails,
        dialogVisible: true,
        courseId: it.courseId,
      };
    },
    closeDialog() {
      this.coursePersonnelDetails.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .page-box {
    text-align: right;
    margin-top: 10px;
  }
}
</style>
